/**
 * Created by r4zi4l on 14.05.2021
 */

const SalePassRulesOptions = {
    name: "SalePassRulesWindow",

    getGuideBundle: function () {
        return bundles.salepassruleswindow;
    },

    stagesContent: function () {
        const styles = cleverapps.styles.SalePassRulesWindow;
        const stage1 = this.initStage(styles.firstStage, (styles, container) => {
            this.addUnitIcon(container, "discountshop", 0, styles.unit);
            this.addSprite(container, this.bundle.frames.blue_light, {
                scale: styles.light.scale,
                x: styles.unit.x,
                y: styles.unit.y,
                zOrder: -1
            });
        });

        const stage2 = this.initStage(styles.secondStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.stand_ground, styles.ground);
            this.addUnitIcon(container, "herochest", 2, styles.unit);

            const star = new cleverapps.Spine(bundles.merge.jsons.salepass_point);
            star.setScale(styles.star.scale || 1.0);
            star.setAnchorPoint(0.5, 0.5);
            star.setAlignment(styles.star);
            star.setAnimation(0, "3_idle", true);
            container.addChild(star);
            star.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.CallFunc(star.clearTrack.bind(star, 0))
            ));
            this.addSprite(star, bundles.guidewindow_arrows.frames.tutorial_hand_png, styles.finger);
        });

        const stage3 = this.initStage(styles.thirdStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.yellow_light, styles.light);
            this.addSprite(container, this.bundle.frames.stand_ground, styles.ground);
            this.addSprite(container, this.bundle.frames.prizes_heap, styles.prizes);
        });

        return [stage1, stage2, stage3];
    }
};

cleverapps.styles.SalePassRulesWindow = {
    firstStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -20 }
        },

        light: {
            scale: 1
        },

        unit: {
            x: 0,
            y: -20,
            scale: 1.7
        }
    },

    secondStage: {
        container: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -50 }
        },

        unit: {
            x: 0,
            y: 10,
            scale: 1.7
        },

        ground: {
            x: 0,
            y: -40
        },

        star: {
            x: 0,
            y: 140,
            scale: 1.7
        },

        finger: {
            x: 160,
            y: -50
        }
    },

    thirdStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -20 }
        },

        light: {
            x: 0,
            y: 30,
            scale: 1.3
        },

        ground: {
            x: 10,
            y: -25,
            scale: 1.7
        },

        prizes: {
            x: 0,
            y: 35
        }
    }
};
